import fetch from "../../uilts/request.js";


export default {
    createTemp(data) {
        return fetch.post("/UploadCredit/createTemp",data)
    },
    previewFileId4(data){
        return fetch.post("/UploadCredit/previewFileId4",data)
    },
    previewFileId5(data){
        return fetch.post("/UploadCredit/previewFileId5",data)
    },
    previewFileId6(data){
        return fetch.post("/UploadCredit/previewFileId6",data)
    },

    downFileId4(data){
        return fetch.post("/UploadCredit/downFileId4",data)
    },
    downFileId5(data){
        return fetch.post("/UploadCredit/downFileId5",data)
    },
    downFileId6(data){
        return fetch.post("/UploadCredit/downFileId6",data)
    },
}
